import { render, staticRenderFns } from "./YPagination.vue?vue&type=template&id=130764f6&scoped=true"
import script from "./YPagination.vue?vue&type=script&lang=js"
export * from "./YPagination.vue?vue&type=script&lang=js"
import style0 from "./YPagination.vue?vue&type=style&index=0&id=130764f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130764f6",
  null
  
)

export default component.exports